import { config } from "../config";

// Loads the Google Maps JS API once, including the experimental 3D maps
// library (`v=beta&libraries=maps3d`) the legacy site relied on. Returns
// a Promise that resolves once `google.maps` and `google.maps.maps3d` are
// ready. Safe to call multiple times — subsequent callers wait on the
// original Promise.

let loadingPromise: Promise<typeof google> | null = null;

declare global {
  interface Window {
    // Callback name reserved for the Maps loader.
    __dwikMapsInit?: () => void;
  }
}

export function loadGoogleMaps(): Promise<typeof google> {
  if (loadingPromise) return loadingPromise;
  if (typeof window !== "undefined" && (window as any).google?.maps?.maps3d) {
    loadingPromise = Promise.resolve((window as any).google);
    return loadingPromise;
  }

  loadingPromise = new Promise<typeof google>((resolve, reject) => {
    window.__dwikMapsInit = () => {
      if ((window as any).google?.maps?.maps3d) {
        resolve((window as any).google);
      } else {
        reject(new Error("google.maps.maps3d failed to load"));
      }
    };

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src =
      `https://maps.googleapis.com/maps/api/js` +
      `?key=${encodeURIComponent(config.googleMapsApiKey)}` +
      `&v=beta&loading=async&libraries=maps3d` +
      `&callback=__dwikMapsInit`;
    script.onerror = () => reject(new Error("Failed to load Google Maps JS"));
    document.head.appendChild(script);
  });

  return loadingPromise;
}
